import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LogOut, Shield, Terminal } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import Button from './ui/Button';
import './GlobalLogout.css';

const GlobalLogout = () => {
    const { authenticated, logout, user } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    if (!authenticated) return null;

    // Hide on Receiver and Host pages (Host handles its own logout/settings in header)
    if (location.pathname === '/receiver' || location.pathname === '/host') return null;

    return (
        <div style={{
            position: 'fixed',
            top: '1rem',
            right: '1rem',
            zIndex: 9999,
            display: 'flex',
            gap: '0.5rem'
        }}>
            {/* User Management Button - For Platform Admins and only on Host page */}
            {(user?.IsPlatformAdmin || user?.Role === 'SuperAdmin' || user?.Role === 'Admin') && location.pathname === '/host' && (
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => navigate('/admin-settings')}
                    title="User Management"
                    className="logout-btn-floating"
                >
                    <Shield size={20} />
                </Button>
            )}

            {/* API Test Harness — SuperAdmin only */}
            {(user?.IsPlatformAdmin || user?.Role === 'SuperAdmin') && (
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => navigate('/api-harness')}
                    title="API Test Harness"
                    className="logout-btn-floating"
                >
                    <Terminal size={20} />
                </Button>
            )}

            <Button
                variant="ghost"
                size="sm"
                onClick={logout}
                title="Logout"
                className="logout-btn-floating"
            >
                <LogOut size={20} />
            </Button>
        </div>
    );
};

export default GlobalLogout;
